import { render, staticRenderFns } from "./EmdPagarmeIcon.vue?vue&type=template&id=051a5b84&"
import script from "./EmdPagarmeIcon.vue?vue&type=script&lang=js&"
export * from "./EmdPagarmeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('051a5b84')) {
      api.createRecord('051a5b84', component.options)
    } else {
      api.reload('051a5b84', component.options)
    }
    module.hot.accept("./EmdPagarmeIcon.vue?vue&type=template&id=051a5b84&", function () {
      api.rerender('051a5b84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emerald/atoms/EmdPagarmeIcon.vue"
export default component.exports